<template>
  <div class="portfolio-grid"
       v-bind:class="{ active: portfolioLoaded }">
    <div class="portfolio-grid-loader d-none"
         v-if="! portfolioLoaded"
         v-resize-text="{ratio: 1, delay: 0}">
      <font-awesome-icon :icon="['far', 'fan']" pulse />
    </div>
    <div class="container-fluid">
      <isotope ref="PortfolioGridIsotope"
               class="portfolio-grid-isotope row"
               v-images-loaded:on.progress="layout"
               :options="getIsotopeOptions()"
               :list="portfolio">
        <div v-for="(item, index) in portfolio"
             v-bind:class="getColumnClass(item)"
             v-bind:key="index">
          <div class="item-image"
               v-bind:class="{ active : item.menu_order }"
               v-on:click="toggleItem(item)">
            <img class="img-fluid"
                 v-bind:src="item.featured.sizes.large"
                 v-bind:height="item.featured.height"
                 v-bind:width="item.featured.width"
                 v-if="item.type === 'project'" />
            <img class="img-fluid"
                 v-bind:src="item.sizes.large"
                 v-bind:height="item.height"
                 v-bind:width="item.width"
                 v-else />
            <div class="klavika-container"
                 v-on:mouseenter="toggleItem(item)"
                 v-on:mouseleave="toggleItem(item)">
              <span class="klavika">D</span>
            </div>
            <div class="item-content">
              <ul class="list-unstyled">
                <li class="list-item title"
                    v-html="item.title.rendered"
                    v-if="item.title.rendered"></li>
                <li class="list-item title"
                    v-html="item.title"
                    v-else></li>
                <li class="list-item caption"
                    v-if="item.caption">{{ item.caption }}</li>
                <li class="list-item description"
                    v-if="item.description">{{ item.description }}</li>
                <li class="list-item description"
                    v-if="item.external_link">
                  <a v-bind:href="item.external_link"
                     class="text-light"
                     target="_blank"><u>website</u></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </isotope>
    </div>
    <div class="portfolio-grid-slider" v-if="portfolioGridSlider">
      <flickity ref="flickity"
                class="flickity"
                :options="getFlickityOptions()">
        <template v-if="portfolio[portfolioIndex].type === 'project'">
          <div class="carousel-cell"
               v-if="portfolio[portfolioIndex].content.rendered.length">
            <div class="container-fluid">
              <div class="row">
                <div class="col-10 offset-1 col-lg-6 offset-lg-3 d-flex flex-column">
                  <ul class="carousel-cell-meta list-unstyled">
                    <li class="list-item title"
                        v-html="portfolio[portfolioIndex].title.rendered"></li>
                    <li class="list-item"
                        v-html="portfolio[portfolioIndex].content.rendered"></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-cell"
               v-for="(item, index) in portfolio[portfolioIndex].portfolio.items"
               v-bind:key="index">
            <div class="container-fluid">
              <div class="row">
                <div class="col-10 offset-1 col-lg-6 offset-lg-3 d-flex flex-column">
                  <img class="carousel-cell-image"
                         v-bind:src="item.sizes.large"
                         v-bind:height="item.height"
                         v-bind:width="item.width" />
                  <ul class="carousel-cell-meta list-unstyled">
                    <li class="list-item title"
                        v-if="item.title">{{ item.title }}</li>
                    <li class="list-item"
                        v-if="item.description">{{ item.description }}</li>
                    <li class="list-item"
                        v-if="item.caption">{{ item.caption }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="carousel-cell"
               v-for="(item, index) in portfolio"
               v-bind:key="index">
            <div class="container-fluid">
              <div class="row">
                <div class="col-10 offset-1 col-lg-6 offset-lg-3 d-flex flex-column">
                  <img class="carousel-cell-image"
                       v-bind:src="item.sizes.large"
                       v-bind:height="item.height"
                       v-bind:width="item.width" />
                  <ul class="carousel-cell-meta list-unstyled">
                    <li class="list-item title"
                        v-html="item.title">{{ item.title }}</li>
                    <li class="list-item"
                        v-if="item.caption">{{ item.caption }}</li>
                    <li class="list-item"
                        v-if="item.description">{{ item.description }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </template>
      </flickity>
      <button class="btn btn-link close-grid-slider"
              v-on:click="closeGridSlider()">
        <font-awesome-icon :icon="['fal', 'times']" />
      </button>
      <button class="btn btn-link prev-next-btn prev"
              v-on:click="previousSlide()">
        <span class="klavika">A</span>
      </button>
      <button class="btn btn-link prev-next-btn next"
              v-on:click="nextSlide()">
        <span class="klavika">B</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'portfolio-grid',
  data () {
    return {
      portfolioGridSlider: false,
      portfolioLoaded: false,
      progressedCount: 0,
      portfolioIndex: 0
    }
  },
  props: {
    portfolio: {
      type: Array,
      required: true
    }
  },
  methods: {
    getColumnClass (item) {
      return 'item col-lg-6 col-xl-5'
    },
    getIsotopeOptions () {
      return {
        layoutMode: 'masonry',
        itemSelector: 'item'
      }
    },
    getFlickityOptions () {
      return {
        initialIndex: this.portfolioIndex,
        prevNextButtons: false,
        adaptiveHeight: true,
        wrapAround: true,
        pageDots: false,
        resize: true
      }
    },
    layout (instance) {
      this.$refs.PortfolioGridIsotope.layout('masonry')
      this.progressedCount += 1
      if (this.progressedCount === instance.images.length) {
        setTimeout(() => (
          this.portfolioLoaded = true
        ), 250)
      }
    },
    openGridSlider (index) {
      this.portfolioIndex = index
      this.portfolioGridSlider = true
    },
    closeGridSlider () {
      this.portfolioGridSlider = false
    },
    nextSlide () {
      this.$refs.flickity.next()
    },
    previousSlide () {
      this.$refs.flickity.previous()
    },
    toggleItem (selected) {
      this.portfolio.map(function (item) {
        if (selected.id === item.id) {
          let b = item.menu_order = !item.menu_order
          return b
        }
        item.menu_order = 0
        return item.menu_order
      })
    }
  }
}
</script>
